const css = `._tags_1av2t_1 {
  align-items: center;
  display: flex;
  gap: 8px;
}
._tags_1av2t_1 ._simplified_1av2t_6 {
  color: var(--secondary-text-color);
}
._tags_1av2t_1 ._simplified_1av2t_6 span::after {
  content: ", ";
}
._tags_1av2t_1 ._simplified_1av2t_6 span:last-child::after {
  content: "";
}
._tags_1av2t_1 ._simplified_1av2t_6 span a {
  white-space: nowrap;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "tags": "_tags_1av2t_1",
  "simplified": "_simplified_1av2t_6"
};